import { render, staticRenderFns } from "./purchase-end.vue?vue&type=template&id=76551755&scoped=true&"
import script from "./purchase-end.vue?vue&type=script&lang=js&"
export * from "./purchase-end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76551755",
  null
  
)

export default component.exports